import { genericProposalDataToForm } from './genericProposalDataToForm';
/**
 * Converts proposal data fields from the API into GenericFormState,
 * merging with defaults from the FormConfig so all fields are present.
 */
export var proposalDataToGenericFormState = function (config, dataFields) {
    return genericProposalDataToForm(config, dataFields);
};
